<template>
  <div class="agent-qa" v-loading.fullscreen.lock="loading" v-loading="dataLoading">
    <el-card class="gpt-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>Agent Settings</span>
        <el-button class="top-botton" type="primary" size="small" icon="el-icon-check"
          @click="setSettings">Save</el-button>
        <el-button class="top-botton top-next-botton" type="" size="small" icon="el-icon-refresh"
          @click="fetchSettings">Fresh</el-button>
      </div>
      <el-form ref="form" :model="form" size="mini" label-width="140px">
        <el-form-item label="Chat Model">
          <el-row :gutter="10">
            <el-col :span="5">
              <el-select v-model="form.chatModel.name" placeholder="Please select provider"
                @change="onChatProviderChange" style="width: 100%;">
                <el-option v-for="provider in chatModelProviders" :key="provider.name" :label="provider.name"
                  :value="provider.name">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="5">
              <el-select v-model="form.chatModel.model" placeholder="Please select model"
                :disabled="!form.chatModel.name" style="width: 100%;">
                <el-option v-for="model in chatModels" :key="model" :label="model" :value="model">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="13">
              <el-input v-model="form.chatModel.token" placeholder="Token" show-password></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="Embedding Model">
          <el-row :gutter="10">
            <el-col :span="5">
              <el-select v-model="form.embeddingModel.name" placeholder="Please select provider"
                @change="onEmbeddingProviderChange" style="width: 100%;">
                <el-option v-for="provider in embeddingModelProviders" :key="provider.name" :label="provider.name"
                  :value="provider.name">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="5">
              <el-select v-model="form.embeddingModel.model" placeholder="Please select model"
                :disabled="!form.embeddingModel.name" style="width: 100%;">
                <el-option v-for="model in embeddingModels" :key="model" :label="model" :value="model">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="13">
              <el-input v-model="form.embeddingModel.token" placeholder="Token" show-password></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="Prompt">
          <el-input type="textarea" :rows="8" v-model="form.prompt" placeholder="Please input prompt">
          </el-input>
        </el-form-item>
        <el-form-item label="Doc Number">
          <el-input-number v-model="form.numDocs" :step="1" :max="10" :min="1">
          </el-input-number>
        </el-form-item>
        <el-form-item label="Threshold">
          <el-input-number v-model="form.threshold" :precision="1" :step="0.1" :max="1" :min="0.1">
          </el-input-number>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="gpt-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>Agent Rag</span>
        <el-button class="top-botton" type="primary" size="small" icon="el-icon-plus"
          @click="openNewRagDialog">Create</el-button>
        <el-button class="top-botton top-next-botton" type="" size="small" icon="el-icon-refresh"
          @click="fetchRagList">Fresh</el-button>
      </div>
      <el-table :data="tableData" row-key="id">
        <el-table-column prop="id" label="Id" width="90"></el-table-column>
        <el-table-column prop="name" label="Name" min-width="140"></el-table-column>
        <el-table-column prop="rows" label="Rows" min-width="30"></el-table-column>
        <el-table-column label="Status" min-width="40">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status | statusFilter" effect="dark" size="small">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Create At" min-width="110">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{
              scope.row.createAt | displayTime()
              }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Update At" min-width="110">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{
              scope.row.updateAt | displayTime()
              }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Detail" min-width="34">
          <template slot-scope="scope">
            <el-button type="primary" circle size="small" icon="el-icon-more" @click="openDetailDialog(scope.row)">
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="Delete" min-width="34">
          <template slot-scope="scope">
            <el-popconfirm title="Confirm delete?" @confirm="deleteRag(scope.row.id)">
              <el-button type="danger" :disabled="scope.row.status === 'waiting' || scope.row.status === 'running'"
                icon="el-icon-delete" circle size="small" slot="reference"></el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :offset.sync="listQuery.offset" :limit.sync="listQuery.limit"
        layout="sizes, prev, pager, next, total " @pagination="fetchRagList" />
    </el-card>
    <el-dialog :visible.sync="dialogVisible" @close="closeRagDialog" :title="ragForm.id && ragForm.id !== 0 ? 'Update Rag' : 'Create Rag'
      " custom-class="add-dialog">
      <el-form ref="ragForm" :model="ragForm" :rules="rules" size="small" label-width="140px">
        <el-form-item label="Name" prop="name" required>
          <el-input :disabled="ragForm.id && ragForm.id !== 0 ? true : false" v-model="ragForm.name"></el-input>
        </el-form-item>
        <el-form-item label="Source File" required>
          <el-upload v-if="!ragForm.id || ragForm.id === 0" ref="upload"
            :action="aiApiRoot + '/v1/admins/agent-chat/upload-rag'" accept=".csv, .xlsx, .docx, .pdf, .txt"
            :headers="{ Authorization: this.token }" :before-upload="beforeUpload" :on-success="onSuccess"
            :on-error="onError" :auto-upload="true" :limit="1" :multiple="false">
            <el-button size="small" slot="trigger" icon="el-icon-upload2">Click to Upload</el-button>
          </el-upload>
          <el-button v-else class="download-btn" icon="el-icon-download" size="small"
            @click="clickDownload">Download</el-button>
          <span>* support file with extension of csv/xlsx/docx/pdf/txt</span>
        </el-form-item>
      </el-form>
      <div class="user-container">
        <user-selection-multi ref="userSelection" :ids="ragForm.userIds ? ragForm.userIds : []"
          @select="selectUserId" />
      </div>
      <span slot="footer">
        <el-button size="small" @click="closeRagDialog">Cancel</el-button>
        <el-button type="primary" size="small" @click="confirmRag">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchAgentSetting,
  setAgentSetting,
  createAgentRag,
  updateAgentRagUsers,
  fetchAgentRagList,
  deleteAgentRag,
  fetchAgentSettingProviders,
} from "@/api/admin";
import { getToken } from "@/utils/auth";
import Pagination from "@/components/Pagination";
import UserSelectionMulti from "./UserSelectionMulti";
import { aiApiRoot } from "@/utils/server";
import { downloadFileAuth } from "@/utils/download-file";

export default {
  components: { Pagination, UserSelectionMulti },
  data() {
    return {
      token: "Bearer " + getToken(),
      aiApiRoot,
      loading: false,
      dataLoading: false,
      form: {
        chatModel: {
          name: "",
          endpoint: "",
          model: "",
          token: ""
        },
        embeddingModel: {
          name: "",
          endpoint: "",
          model: "",
          token: ""
        },
        prompt: "",
        numDocs: 4,
        threshold: 0.6
      },
      lastEmbeddingModel: "",
      chatModelProviders: [],
      embeddingModelProviders: [],
      chatModels: [],
      embeddingModels: [],
      ragForm: {},
      rules: {
        name: [{ required: true }],
      },
      tableData: [],
      listQuery: {
        offset: 0,
        limit: 10,
      },
      total: 0,
      dialogVisible: false,
      providersLoaded: false // Track if providers have been loaded
    };
  },
  mounted() {
    this.active();
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        waiting: "warning",
        running: "",
        done: "success",
        abort: "info",
        error: "danger",
      };
      return statusMap[status];
    },
  },
  methods: {
    active() {
      this.initRagForm();
      this.fetchSettings();
      this.fetchRagList();
      // Providers will be loaded via fetchSettings -> fetchProviders if needed
    },
    initRagForm() {
      this.ragForm = {
        name: "",
        group: "agentQa",
        userIds: [],
      };
    },
    selectUserId(ids) {
      this.ragForm.userIds = ids;
    },
    clearForm() {
      this.form = {
        chatModel: {
          name: "",
          endpoint: "",
          model: "",
          token: ""
        },
        embeddingModel: {
          name: "",
          endpoint: "",
          model: "",
          token: ""
        },
        prompt: "",
        numDocs: 4,
        threshold: 0.6
      }
    },
    openDetailDialog(row) {
      // 使用深拷贝避免直接引用表格数据
      this.ragForm = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.userSelection && this.$refs.userSelection.reopen();
      });
    },
    closeRagDialog() {
      this.dialogVisible = false;
      this.$refs.ragForm.resetFields();
      this.initRagForm();
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    fetchSettings() {
      this.dataLoading = true;
      fetchAgentSetting({ category: "qa" })
        .then((response) => {
          if (response.success) {
            this.clearForm();
            // Map the response data to the new form structure
            this.form.chatModel = {
              name: response.result.chatModel?.name || "",
              endpoint: response.result.chatModel?.endpoint || "",
              model: response.result.chatModel?.model || "",
              token: response.result.chatModel?.token || ""
            };

            this.form.embeddingModel = {
              name: response.result.embeddingModel?.name || "",
              endpoint: response.result.embeddingModel?.endpoint || "",
              model: response.result.embeddingModel?.model || "",
              token: response.result.embeddingModel?.token || ""
            };

            this.form.prompt = response.result.prompt || "";
            this.form.numDocs = response.result.numDocs || 4;
            this.form.threshold = response.result.threshold || 0.6;

            // Save original settings for comparison
            this.lastEmbeddingModel = response.result.embeddingModel?.model || "";

            // Load models for the current providers after data is set
            this.$nextTick(() => {
              if (this.providersLoaded) {
                // If providers already loaded, just load models for current selections
                this.loadChatModelsForProvider(this.form.chatModel.name);
                this.loadEmbeddingModelsForProvider(this.form.embeddingModel.name);
              } else {
                // If providers not yet loaded, fetch them which will also load models
                this.fetchProviders();
              }
            });
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    setSettings() {
      // Check if embeddingModel.model has been modified
      if (this.form.embeddingModel.model !== this.lastEmbeddingModel) {
        // Show confirmation dialog
        this.$confirm('All rag docs need to process again, confirm?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.submitSettings();
        }).catch(() => {
          // User cancelled the operation
        });
      } else {
        // No modification to embeddingModel.model, submit directly
        this.submitSettings();
      }
    },
    submitSettings() {
      this.dataLoading = true;
      setAgentSetting(this.form)
        .then((response) => {
          if (response.success) {
            this.$notify({
              title: "Update successful",
              type: "success",
            });
            this.fetchSettings();
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    openNewRagDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.userSelection && this.$refs.userSelection.reopen();
      });
    },
    confirmRag() {
      this.$refs.ragForm.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.ragForm.id || this.ragForm.id === 0) {
          if (!this.ragForm.fileKey) {
            this.$message({
              showClose: false,
              message: "Please upload source file",
              type: "error",
            });
          }
          createAgentRag(this.ragForm).then((response) => {
            if (response.success) {
              this.$notify({
                title: "Create successful",
                type: "success",
              });
            }
          }).finally(() => {
            this.closeRagDialog();
            this.fetchRagList();
          });
        } else {
          updateAgentRagUsers(this.ragForm.id, this.ragForm).then(response => {
            if (response.success) {
              this.$notify({
                title: "Update successful",
                type: "success",
              });
            }
          }).finally(() => {
            this.closeRagDialog();
            this.fetchRagList();
          })
        }
      });
    },
    deleteRag(id) {
      this.dataLoading = true;
      deleteAgentRag(id)
        .then((response) => {
          this.dataLoading = false;
          if (response.success) {
            this.$notify({
              title: "Delete successful",
              type: "success",
            });
            this.fetchRagList();
          }
        })
        .catch(() => {
          this.dataLoading = false;
        });
    },
    fetchRagList() {
      this.dataLoading = true;
      fetchAgentRagList(this.listQuery).then((response) => {
        if (response.success) {
          this.tableData = response.result.items || [];
          this.total = response.result.totalCount;
        }
      }).finally(() => {
        this.dataLoading = false;
      });
    },
    fetchProviders() {
      // Avoid fetching providers if already loaded
      if (this.providersLoaded) {
        // But still ensure models are loaded for current providers
        this.loadChatModelsForProvider(this.form.chatModel.name);
        this.loadEmbeddingModelsForProvider(this.form.embeddingModel.name);
        return;
      }

      fetchAgentSettingProviders().then(response => {
        if (response.success) {
          this.chatModelProviders = response.result.models || [];
          this.embeddingModelProviders = response.result.embeddingModels || [];
          this.providersLoaded = true;

          // Load models for currently selected providers
          this.loadChatModelsForProvider(this.form.chatModel.name);
          this.loadEmbeddingModelsForProvider(this.form.embeddingModel.name);
        }
      });
    },
    onChatProviderChange(providerName) {
      const provider = this.chatModelProviders.find(p => p.name === providerName);
      this.chatModels = provider ? provider.models : [];
      // Reset model selection when provider changes
      this.form.chatModel.model = "";
      // Set endpoint when provider changes
      if (provider) {
        this.form.chatModel.endpoint = provider.endpoint || "";
      } else {
        this.form.chatModel.endpoint = "";
      }
    },
    onEmbeddingProviderChange(providerName) {
      const provider = this.embeddingModelProviders.find(p => p.name === providerName);
      this.embeddingModels = provider ? provider.models : [];
      // Reset model selection when provider changes
      this.form.embeddingModel.model = "";
      // Set endpoint when provider changes
      if (provider) {
        this.form.embeddingModel.endpoint = provider.endpoint || "";
      } else {
        this.form.embeddingModel.endpoint = "";
      }
    },
    beforeUpload() {
      this.ragForm.fileKey = "";
      this.loading = true;
      return true;
    },
    onSuccess(response) {
      this.loading = false;
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      if (response.success) {
        this.ragForm.fileKey = response.result ? response.result.fileKey : "";
      } else {
        this.$message({
          showClose: false,
          message: response && response.error ? response.error.message : "",
          type: "error",
        });
      }
    },
    onError(err) {
      this.loading = false;
      this.ragForm.fileKey = "";
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      if (err && err.message) {
        let res = JSON.parse(err.message);
        if (res && res.error && res.error.message) {
          this.$message({
            showClose: false,
            message: res.error.message,
            type: "error",
          });
          return;
        }
      }
      this.$message({
        showClose: false,
        message: err,
        type: "error",
      });
    },
    clickDownload() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.preparingData"),
      });
      downloadFileAuth(
        aiApiRoot + '/v1/admins/agent-chat/download-rag/' + this.ragForm.id,
        extractLastPart(this.ragForm.fileKey),
        getToken(),
        () => {
          loading.close();
        }
      );
    },
    loadChatModelsForProvider(providerName) {
      if (providerName) {
        const provider = this.chatModelProviders.find(p => p.name === providerName);
        this.chatModels = provider ? provider.models : [];
      }
    },

    loadEmbeddingModelsForProvider(providerName) {
      if (providerName) {
        const provider = this.embeddingModelProviders.find(p => p.name === providerName);
        this.embeddingModels = provider ? provider.models : [];
      }
    },
  }
}

function extractLastPart(input) {
  if (!input) {
    return null;
  }
  const lastSlashIndex = input.lastIndexOf('/');
  if (lastSlashIndex === -1) {
    return input;
  }
  const afterSlash = input.substring(lastSlashIndex + 1);
  const firstDashIndex = afterSlash.indexOf('-');
  if (firstDashIndex === -1) {
    return afterSlash;
  }
  return afterSlash.substring(firstDashIndex + 1);
}
</script>

<style lang="scss" scoped>
.agent-qa {
  .gpt-card {
    margin-bottom: 10px;

    .top-botton {
      float: right;
      margin-top: -8px;
      margin-bottom: -8px
    }

    .top-next-botton {
      margin-right: 10px;
    }
  }

  ::v-deep .add-dialog .el-form {
    margin-top: 10px;
    margin-bottom: -10px;
    width: 90%;
  }

  .download-btn {
    display: block;
  }

  .user-container {
    margin-top: 30px;
    border: 1px solid #e8e8e8;
    border-radius: 5px;
    padding: 20px 10px 0;
  }
}
</style>